export const buildCheckoutUrl = (wizardUrl: unknown, contractToken: unknown): string | null => {
    const baseUrl = String(wizardUrl || '').trim().replace(/^\/\//, 'https://')
    const token = String(contractToken || '')
    if (!baseUrl || !token) return null

    try {
        const url = new URL(baseUrl.includes('://') ? baseUrl : `https://${baseUrl}`)
        if (url.protocol !== 'https:' && url.protocol !== 'http:') return null

        url.pathname = `${url.pathname.replace(/\/+$/, '')}/checkout`
        url.search = `?token=${encodeURIComponent(token)}`
        url.hash = ''

        return url.href
    } catch {
        return null
    }
}
